module.exports = __webpack_public_path__ + "img/HEI_illustration.a8badf89.png";